// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Order } from "../flow/types";

export default function (
    state: Order = initialState.selectedOrder,
  action: any
) {
  switch (action.type) {
      case ActionTypes.GET_ORDER + ActionTypes.FULFILLED:
      return action.payload.data;
    default:
      return state;
  }
}
